import { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import KasaEkrani from './KasaEkrani';
import Login from './Login';
import LandingPage from './LandingPage';
import MenuBackground from './MenuBackground';
import './App.css';
import Register from './Register';
import { auth } from './firebaseClient';
import AdminPanel from './AdminPanel';
import MutfakEkrani from './MutfakEkrani';
import SuperAdmin from './SuperAdmin';
import OdemeBasarili from './odeme-basarili';
import OdemeHatasi from './odeme-hatasi';

const BACKEND = 'https://3amenu.com/api';

const DILLER = {
  tr: {
    menuYukleniyor: 'Menü yükleniyor...',
    masa: 'Masa', kategoriler: 'Kategoriler', menuGoruntule: 'Menüyü Görüntüle',
    dijitalMenuKesfedin: 'Dijital menüyü keşfedin', tanitimVideo: 'Tanıtım Videosu',
    menuHazirlanmamis: 'Menü henüz hazırlanmamış', goruntule: 'Görüntüle',
    tumUrunler: 'Tümü', urunSayisi: 'Ürün', urun: 'ürün',
    garson: '🔔 Garson', adisyon: '🧾 Adisyon', hesapIstendi: '✅ İstendi',
    hesap: '💳 Hesap', siparisVer: '🛒 Sipariş', siparisAlindi: 'Siparişiniz alındı! 🎉',
    garsonCagrildi: 'Garson çağrıldı! 🔔', hesapGeliyor: 'Hesabınız geliyor! 💳',
    hata: 'Hata oluştu, tekrar deneyin.', adisyonBaslik: '🧾 Adisyonum',
    henuzSiparis: 'Henüz sipariş verilmedi', toplam: 'Toplam', kapat: 'Kapat',
    talepGonderildi: 'talebi gönderildi!', adisyonAlinamadi: 'Adisyon alınamadı!',
    degerlendirBaslik: '⭐ Deneyiminizi Değerlendirin', degerlendirAlt: 'Bize birkaç saniyenizi ayırır mısınız?',
    yorumPlaceholder: 'Yorumunuzu yazın... (opsiyonel)', gonder: 'Gönder', atla: 'Atla',
    tesekkurler: 'Teşekkürler! 🙏', degerlendirmeAlindi: 'Değerlendirmeniz alındı.',
    puanSec: 'Lütfen puan seçin!', dilSec: 'Dil seçin', googleYorum: "Google'da da Değerlendirin",
    aramaPlaceholder: 'Ürün ara...', aramaYok: 'Ürün bulunamadı',
    favoriler: 'Favorilerim', favoriYok: 'Henüz favori eklemediniz',
    sepeteEkle: 'Sepete Ekle', detay: 'Detay',
    alerjenler: 'Alerjenler', kalori: 'Kalori',
  },
  en: {
    menuYukleniyor: 'Loading menu...', masa: 'Table', kategoriler: 'Categories',
    menuGoruntule: 'View Menu', dijitalMenuKesfedin: 'Explore our digital menu',
    tanitimVideo: 'Intro Video', menuHazirlanmamis: 'Menu not ready yet',
    goruntule: 'View', tumUrunler: 'All', urunSayisi: 'Items', urun: 'item(s)',
    garson: '🔔 Waiter', adisyon: '🧾 My Bill', hesapIstendi: '✅ Requested',
    hesap: '💳 Bill', siparisVer: '🛒 Order', siparisAlindi: 'Your order has been received! 🎉',
    garsonCagrildi: 'Waiter called! 🔔', hesapGeliyor: 'Your bill is on the way! 💳',
    hata: 'An error occurred, please try again.', adisyonBaslik: '🧾 My Bill',
    henuzSiparis: 'No orders yet', toplam: 'Total', kapat: 'Close',
    talepGonderildi: 'request sent!', adisyonAlinamadi: 'Could not load bill!',
    degerlendirBaslik: '⭐ Rate Your Experience', degerlendirAlt: 'Could you spare a few seconds?',
    yorumPlaceholder: 'Write your comment... (optional)', gonder: 'Submit', atla: 'Skip',
    tesekkurler: 'Thank you! 🙏', degerlendirmeAlindi: 'Your review has been received.',
    puanSec: 'Please select a rating!', dilSec: 'Select language', googleYorum: 'Review on Google',
    aramaPlaceholder: 'Search products...', aramaYok: 'No products found',
    favoriler: 'My Favorites', favoriYok: 'No favorites yet',
    sepeteEkle: 'Add to Cart', detay: 'Detail',
    alerjenler: 'Allergens', kalori: 'Calories',
  },
  ar: {
    menuYukleniyor: 'جاري تحميل القائمة...', masa: 'طاولة', kategoriler: 'الفئات',
    menuGoruntule: 'عرض القائمة', dijitalMenuKesfedin: 'استكشف قائمتنا الرقمية',
    tanitimVideo: 'فيديو تعريفي', menuHazirlanmamis: 'القائمة غير جاهزة بعد',
    goruntule: 'عرض', tumUrunler: 'الكل', urunSayisi: 'عناصر', urun: 'عنصر',
    garson: '🔔 نادل', adisyon: '🧾 فاتورتي', hesapIstendi: '✅ تم الطلب',
    hesap: '💳 الحساب', siparisVer: '🛒 اطلب', siparisAlindi: 'تم استلام طلبك! 🎉',
    garsonCagrildi: 'تم استدعاء النادل! 🔔', hesapGeliyor: 'فاتورتك في الطريق! 💳',
    hata: 'حدث خطأ، يرجى المحاولة مرة أخرى.', adisyonBaslik: '🧾 فاتورتي',
    henuzSiparis: 'لا طلبات بعد', toplam: 'المجموع', kapat: 'إغلاق',
    talepGonderildi: 'تم الإرسال!', adisyonAlinamadi: 'تعذر تحميل الفاتورة!',
    degerlendirBaslik: '⭐ قيّم تجربتك', degerlendirAlt: 'هل يمكنك تخصيص بضع ثوانٍ؟',
    yorumPlaceholder: 'اكتب تعليقك... (اختياري)', gonder: 'إرسال', atla: 'تخطي',
    tesekkurler: 'شكراً! 🙏', degerlendirmeAlindi: 'تم استلام تقييمك.',
    puanSec: 'يرجى تحديد تقييم!', dilSec: 'اختر اللغة', googleYorum: 'قيّم على Google',
    aramaPlaceholder: 'ابحث عن المنتجات...', aramaYok: 'لا توجد منتجات',
    favoriler: 'المفضلة', favoriYok: 'لا مفضلات بعد',
    sepeteEkle: 'أضف للسلة', detay: 'تفاصيل',
    alerjenler: 'مسببات الحساسية', kalori: 'سعرات حرارية',
  },
  ru: {
    menuYukleniyor: 'Загрузка меню...', masa: 'Стол', kategoriler: 'Категории',
    menuGoruntule: 'Открыть меню', dijitalMenuKesfedin: 'Изучите наше цифровое меню',
    tanitimVideo: 'Видео', menuHazirlanmamis: 'Меню ещё не готово',
    goruntule: 'Смотреть', tumUrunler: 'Все', urunSayisi: 'Позиций', urun: 'позиция',
    garson: '🔔 Официант', adisyon: '🧾 Мой счёт', hesapIstendi: '✅ Запрошено',
    hesap: '💳 Счёт', siparisVer: '🛒 Заказать', siparisAlindi: 'Ваш заказ принят! 🎉',
    garsonCagrildi: 'Официант вызван! 🔔', hesapGeliyor: 'Ваш счёт уже несут! 💳',
    hata: 'Произошла ошибка, попробуйте ещё раз.', adisyonBaslik: '🧾 Мой счёт',
    henuzSiparis: 'Заказов пока нет', toplam: 'Итого', kapat: 'Закрыть',
    talepGonderildi: 'запрос отправлен!', adisyonAlinamadi: 'Не удалось загрузить счёт!',
    degerlendirBaslik: '⭐ Оцените ваш опыт', degerlendirAlt: 'Уделите нам несколько секунд?',
    yorumPlaceholder: 'Напишите комментарий... (необязательно)', gonder: 'Отправить', atla: 'Пропустить',
    tesekkurler: 'Спасибо! 🙏', degerlendirmeAlindi: 'Ваш отзыв получен.',
    puanSec: 'Пожалуйста, выберите оценку!', dilSec: 'Выберите язык', googleYorum: 'Оценить в Google',
    aramaPlaceholder: 'Поиск блюд...', aramaYok: 'Ничего не найдено',
    favoriler: 'Избранное', favoriYok: 'Избранного пока нет',
    sepeteEkle: 'В корзину', detay: 'Детали',
    alerjenler: 'Аллергены', kalori: 'Калории',
  },
};

// ─── Ürün Detay Modal ───────────────────────
function UrunDetayModal({ urun, temaRenk, onKapat, onSepeteEkle, sepetteMi, arkaPlanVideoUrl, t, oneriUrunler = [], onUrunSec }) {
  if (!urun) return null;
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-end justify-center" onClick={e => { if (e.target === e.currentTarget) onKapat(); }}>
      <div className="rounded-t-3xl w-full max-w-md overflow-hidden" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(20,20,20,0.95)' : 'white', backdropFilter: 'blur(20px)', maxHeight: '85vh', overflowY: 'auto' }}>
        {urun.resim && (
          <div className="relative h-56 overflow-hidden">
            <img src={urun.resim} alt={urun.ad} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <button onClick={onKapat} className="absolute top-4 right-4 bg-black/40 text-white w-8 h-8 rounded-full flex items-center justify-center text-lg">✕</button>
          </div>
        )}
        <div className="p-5">
          {!urun.resim && (
            <div className="flex justify-between items-center mb-3">
              <div />
              <button onClick={onKapat} className="text-gray-400 text-2xl">✕</button>
            </div>
          )}
          <h2 className="text-xl font-bold mb-2" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{urun.ad}</h2>
          {urun.aciklama && <p className="text-sm mb-3 leading-relaxed" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#6b7280' }}>{urun.aciklama}</p>}

          <div className="flex gap-3 mb-4 flex-wrap">
            {urun.kalori && (
              <div className="flex items-center gap-1.5 bg-orange-50 text-orange-600 px-3 py-1.5 rounded-xl text-xs font-medium">
                🔥 {urun.kalori} kcal
              </div>
            )}
            {urun.alerjenler?.length > 0 && (
              <div className="flex items-center gap-1.5 bg-yellow-50 text-yellow-700 px-3 py-1.5 rounded-xl text-xs font-medium">
                ⚠️ {urun.alerjenler.join(', ')}
              </div>
            )}
          </div>

          <div className="flex justify-between items-center">
            <p className="text-2xl font-bold" style={{ color: temaRenk }}>₺{urun.fiyat}</p>
            {urun.stokta === false ? (
              <span className="text-sm font-semibold text-red-400 bg-red-50 px-5 py-3 rounded-2xl">Tükendi</span>
            ) : (
              <button onClick={() => { onSepeteEkle(urun); onKapat(); }}
                className="text-white px-6 py-3 rounded-2xl font-bold text-sm"
                style={{ backgroundColor: temaRenk }}>
                {sepetteMi ? `✅ ${t.sepeteEkle}` : `+ ${t.sepeteEkle}`}
              </button>
            )}
          </div>
        </div>
        {oneriUrunler.length > 0 && (
  <div className="px-5 pb-5">
    <p className="text-xs font-bold uppercase tracking-wider mb-3" style={{ color: temaRenk }}>🔥 Bunları da Deneyin</p>
    <div className="flex gap-3 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none' }}>
      {oneriUrunler.map(u => (
        <div key={u.id} onClick={() => { onKapat(); setTimeout(() => onUrunSec(u), 100); }}
          className="flex-shrink-0 rounded-xl overflow-hidden cursor-pointer"
          style={{ width: '110px', backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : '#f9fafb' }}>
          {u.resim
            ? <img src={u.resim} alt={u.ad} className="w-full object-cover" style={{ height: '70px' }} />
            : <div className="w-full flex items-center justify-center text-2xl" style={{ height: '70px', backgroundColor: temaRenk + '20' }}>🍽️</div>}
          <div className="p-2">
            <p className="text-xs font-semibold leading-tight" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{u.ad}</p>
            <p className="text-xs font-bold mt-1" style={{ color: temaRenk }}>₺{u.fiyat}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
)}
      </div>
    </div>
  );
}

// ─── Arama Modal ────────────────────────────
function AramaModal({ urunler, temaRenk, onKapat, onUrunSec, sepet, onSepeteEkle, onSepettenCikar, arkaPlanVideoUrl, t }) {
  const [aramaMetni, setAramaMetni] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { setTimeout(() => inputRef.current?.focus(), 100); }, []);

  const sonuclar = aramaMetni.length >= 1
    ? urunler.filter(u => u.ad.toLowerCase().includes(aramaMetni.toLowerCase()) || u.aciklama?.toLowerCase().includes(aramaMetni.toLowerCase()))
    : [];

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(10,10,10,0.97)' : '#f9fafb', backdropFilter: 'blur(20px)' }}>
      {/* Arama bar */}
      <div className="px-4 pt-4 pb-3" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.05)' : 'white', borderBottom: `1px solid ${arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : '#f3f4f6'}` }}>
        <div className="flex items-center gap-3">
          <div className="flex-1 flex items-center gap-2 rounded-xl px-4 py-2.5" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : '#f3f4f6' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={arkaPlanVideoUrl ? 'rgba(255,255,255,0.5)' : '#9ca3af'} strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
            <input ref={inputRef} value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
              placeholder={t.aramaPlaceholder} className="flex-1 bg-transparent outline-none text-sm"
              style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }} />
            {aramaMetni && <button onClick={() => setAramaMetni('')} style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.5)' : '#9ca3af' }}>✕</button>}
          </div>
          <button onClick={onKapat} className="font-medium text-sm" style={{ color: temaRenk }}>Kapat</button>
        </div>
      </div>

      {/* Sonuçlar */}
      <div className="flex-1 overflow-y-auto p-4">
        {aramaMetni.length === 0 ? (
          <div className="text-center py-12" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.3)' : '#9ca3af' }}>
            <p className="text-4xl mb-3">🔍</p>
            <p className="text-sm">Aramak istediğiniz ürünü yazın</p>
          </div>
        ) : sonuclar.length === 0 ? (
          <div className="text-center py-12" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.3)' : '#9ca3af' }}>
            <p className="text-4xl mb-3">😕</p>
            <p className="text-sm">{t.aramaYok}</p>
          </div>
        ) : (
          sonuclar.map(urun => (
            <div key={urun.id} className="rounded-2xl mb-3 overflow-hidden flex items-center gap-3 p-3"
              style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.08)' : 'white' }}
              onClick={() => onUrunSec(urun)}>
              {urun.resim
                ? <img src={urun.resim} alt={urun.ad} className="w-16 h-16 rounded-xl object-cover flex-shrink-0" />
                : <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 text-2xl" style={{ backgroundColor: temaRenk + '20' }}>🍽️</div>
              }
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{urun.ad}</p>
                {urun.aciklama && <p className="text-xs mt-0.5 truncate" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.5)' : '#9ca3af' }}>{urun.aciklama}</p>}
                <p className="font-bold text-sm mt-1" style={{ color: temaRenk }}>₺{urun.fiyat}</p>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                {urun.stokta === false ? (
                  <span className="text-xs font-semibold text-red-400 bg-red-50 px-2 py-1 rounded-full">Tükendi</span>
                ) : (
                  <>
                    {sepet[urun.id] && (
                      <>
                        <button onClick={e => { e.stopPropagation(); onSepettenCikar(urun); }}
                          className="w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm"
                          style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', color: arkaPlanVideoUrl ? 'white' : '#374151' }}>−</button>
                        <span className="font-bold text-sm w-4 text-center" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{sepet[urun.id].adet}</span>
                      </>
                    )}
                    <button onClick={e => { e.stopPropagation(); onSepeteEkle(urun); }}
                      className="w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm text-white"
                      style={{ backgroundColor: temaRenk }}>+</button>
                  </>
                )}
              </div>
            </div>            
          ))
        )}
        </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// PUBLIC MENÜ — /menu/:cafeId (masasız)
// ─────────────────────────────────────────────
function PublicMenu() {
  const { cafeId } = useParams();
  const [kategoriler, setKategoriler] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [kafeAdi, setKafeAdi] = useState('');
  const [tagline, setTagline] = useState('');
  const [temaRenk, setTemaRenk] = useState('#f97316');
  const [logoUrl, setLogoUrl] = useState('');
  const [sosyalMedya, setSosyalMedya] = useState({});
  const [arkaPlanVideoUrl, setArkaPlanVideoUrl] = useState('');
  const [blurYogunluk, setBlurYogunluk] = useState(8);
  const [overlayOpacity, setOverlayOpacity] = useState(0.55);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [secilenKategori, setSecilenKategori] = useState(null);
  const [secilenAltKategori, setSecilenAltKategori] = useState('tumu');
  const [dil, setDil] = useState(() => localStorage.getItem('menu_dil') || 'tr');
  const [pasif, setPasif] = useState(false);
  const [aramaAcik, setAramaAcik] = useState(false);
  const [secilenUrun, setSecilenUrun] = useState(null);
  const [favoriler, setFavoriler] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`fav_${cafeId}`) || '[]'); } catch { return []; }
  });
  const [favoriSekmesi, setFavoriSekmesi] = useState(false);
  const t = DILLER[dil];

  const favoriToggle = (urunId) => {
    setFavoriler(prev => {
      const yeni = prev.includes(urunId) ? prev.filter(id => id !== urunId) : [...prev, urunId];
      localStorage.setItem(`fav_${cafeId}`, JSON.stringify(yeni));
      return yeni;
    });
  };

  useEffect(() => {
    const getir = async () => {
      try {
        const kafeRes = await fetch(`${BACKEND}/menu/kafe/${cafeId}`).then(r => r.json());
        if (!kafeRes || !kafeRes.cafeId) { setYukleniyor(false); return; }
        if (kafeRes.aktif === false) { setYukleniyor(false); setPasif(true); return; }
        setKafeAdi(kafeRes.ad || '');
        setTagline(kafeRes.tagline || '');
        setTemaRenk(kafeRes.temaRenk || '#f97316');
        setLogoUrl(kafeRes.logoUrl || '');
        setSosyalMedya(kafeRes.sosyalMedya || {});
        if (kafeRes.videoUrl) setArkaPlanVideoUrl(kafeRes.videoUrl);
        if (kafeRes.blurYogunluk != null) setBlurYogunluk(kafeRes.blurYogunluk);
        if (kafeRes.overlayOpacity != null) setOverlayOpacity(kafeRes.overlayOpacity);
        const [k, u] = await Promise.all([
          fetch(`${BACKEND}/menu/${kafeRes.cafeId}`).then(r => r.json()),
          fetch(`${BACKEND}/menu/urunler/${kafeRes.cafeId}`).then(r => r.json()),
        ]);
        setKategoriler(Array.isArray(k) ? k : []);
        setUrunler(Array.isArray(u) ? u : []);
      } catch (err) { console.error(err); }
      setYukleniyor(false);
    };
    getir();
  }, [cafeId]);

  if (yukleniyor) return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="text-white/60 text-sm">Menü yükleniyor...</div>
    </div>
  );

  if (pasif) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 px-6 text-center">
      <div className="text-5xl mb-6">🔒</div>
      <h1 className="text-xl font-bold text-white mb-3">Menü Geçici Olarak Kapalı</h1>
      <p className="text-white/50 text-sm">Bu menü şu anda aktif değil. Lütfen daha sonra tekrar deneyin.</p>
    </div>
  );

  const kategoriUrunleri = secilenKategori ? urunler.filter(u => u.kategoriId === secilenKategori.id) : [];
  const altKategoriler = secilenKategori ? [...new Set(kategoriUrunleri.map(u => u.altKategori).filter(Boolean))] : [];
  const filtreliUrunler = secilenKategori
    ? (secilenAltKategori === 'tumu' ? kategoriUrunleri : kategoriUrunleri.filter(u => u.altKategori === secilenAltKategori))
    : [];
  const favoriUrunler = urunler.filter(u => favoriler.includes(u.id));

  const UrunKart = ({ urun }) => (
    <div className="bg-white rounded-2xl shadow-sm mb-3 overflow-hidden cursor-pointer" onClick={() => setSecilenUrun(urun)}>
      {urun.resim && <div className="overflow-hidden h-40 relative">
        <img src={urun.resim} alt={urun.ad} className="w-full h-full object-cover" />
        <button onClick={e => { e.stopPropagation(); favoriToggle(urun.id); }}
          className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center text-lg shadow">
          {favoriler.includes(urun.id) ? '❤️' : '🤍'}
        </button>
      </div>}
      <div className="p-4 flex justify-between items-center">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-gray-800">{urun.ad}</h3>
            {!urun.resim && (
              <button onClick={e => { e.stopPropagation(); favoriToggle(urun.id); }} className="text-lg">
                {favoriler.includes(urun.id) ? '❤️' : '🤍'}
              </button>
            )}
          </div>
          {urun.aciklama && <p className="text-sm text-gray-500 mt-1">{urun.aciklama}</p>}
          {urun.kalori && <p className="text-xs text-gray-400 mt-1">🔥 {urun.kalori} kcal</p>}
          <p className="font-bold mt-2 text-lg" style={{ color: temaRenk }}>₺{urun.fiyat}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen relative" dir={dil === 'ar' ? 'rtl' : 'ltr'} style={{ backgroundColor: arkaPlanVideoUrl ? 'transparent' : '#f9fafb' }}>
      <MenuBackground videoUrl={arkaPlanVideoUrl} blurYogunluk={blurYogunluk} overlayOpacity={overlayOpacity} />

      {aramaAcik && (
        <AramaModal urunler={urunler} temaRenk={temaRenk} onKapat={() => setAramaAcik(false)}
          onUrunSec={u => { setSecilenUrun(u); setAramaAcik(false); }}
          sepet={{}} onSepeteEkle={() => {}} onSepettenCikar={() => {}}
          arkaPlanVideoUrl={arkaPlanVideoUrl} t={t} />
      )}

      {secilenUrun && (
        <UrunDetayModal urun={secilenUrun} temaRenk={temaRenk} onKapat={() => setSecilenUrun(null)}
          onSepeteEkle={() => {}} sepetteMi={false} arkaPlanVideoUrl={arkaPlanVideoUrl} t={t} />
      )}

      <div className="relative z-10 max-w-md mx-auto pb-8">
        <div className="sticky top-0 z-10 shadow-sm"
          style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : 'white', backdropFilter: arkaPlanVideoUrl ? 'blur(12px)' : 'none' }}>
          <div className="flex items-center justify-between px-4 py-3">
            <button onClick={() => { if (favoriSekmesi) { setFavoriSekmesi(false); } else if (secilenKategori) { setSecilenKategori(null); setSecilenAltKategori('tumu'); } }}
              style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#9ca3af', visibility: (secilenKategori || favoriSekmesi) ? 'visible' : 'hidden' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            <div className="flex items-center gap-2">
              {logoUrl && <img src={logoUrl} alt="logo" className="w-7 h-7 rounded-full object-cover" />}
              <div className="text-center">
                <p className="text-sm font-bold leading-tight" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{kafeAdi}</p>
                {tagline && <p className="text-xs leading-tight" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>{tagline}</p>}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setAramaAcik(true)} style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#9ca3af' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              </button>
              <button onClick={() => { setFavoriSekmesi(true); setSecilenKategori(null); }}
                style={{ color: favoriler.length > 0 ? '#ef4444' : (arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#9ca3af') }}>
                {favoriler.length > 0 ? '❤️' : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>}
              </button>
              <div className="flex items-center gap-1" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', borderRadius: '20px', padding: '2px' }}>
                <button onClick={() => { setDil('tr'); localStorage.setItem('menu_dil', 'tr'); }} className="px-2 py-1 text-xs font-bold rounded-full transition-all"
                  style={dil === 'tr' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>TR</button>
                <button onClick={() => { setDil('en'); localStorage.setItem('menu_dil', 'en'); }} className="px-2 py-1 text-xs font-bold rounded-full transition-all"
                  style={dil === 'en' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>EN</button>
              </div>
            </div>
          </div>
          <div className="px-4 py-1.5 text-center text-xs" style={{ backgroundColor: temaRenk + '15', color: temaRenk }}>
            📋 Dijital Menü — Sipariş için masanızdaki QR'ı okutun
          </div>
        </div>

        {/* Favoriler sekmesi */}
        {favoriSekmesi ? (
          <div className="p-4">
            <h2 className="font-bold text-lg mb-4" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>❤️ {t.favoriler}</h2>
            {favoriUrunler.length === 0 ? (
              <div className="text-center py-12" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af' }}>
                <p className="text-4xl mb-3">🤍</p>
                <p className="text-sm">{t.favoriYok}</p>
              </div>
            ) : favoriUrunler.map(urun => <UrunKart key={urun.id} urun={urun} />)}
          </div>
        ) : !secilenKategori ? (
          <div>
            {!secilenKategori && (
              <div className="flex gap-3 justify-center py-4 flex-wrap px-4">
                {sosyalMedya.googleMaps && <a href={sosyalMedya.googleMaps} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-xl flex items-center justify-center shadow" style={{ background: 'linear-gradient(135deg, #EA4335, #FBBC05)' }}><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="white"/><circle cx="12" cy="9" r="2.5" fill="#EA4335"/></svg></a>}
                {sosyalMedya.whatsapp && <a href={`https://wa.me/${sosyalMedya.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-xl flex items-center justify-center shadow" style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)' }}><svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></a>}
                {sosyalMedya.instagram && <a href={sosyalMedya.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-xl flex items-center justify-center shadow" style={{ background: 'linear-gradient(135deg, #F58529, #DD2A7B, #8134AF)' }}><svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg></a>}
              </div>
            )}
            
            {kategoriler.length === 0 ? (
              <div className="p-12 text-center" style={{ color: '#9ca3af' }}>Menü henüz hazırlanmamış</div>
            ) : (
              kategoriler.map(kat => {
                const urunSayisi = urunler.filter(u => u.kategoriId === kat.id).length;
                return (
                  <div key={kat.id} onClick={() => { setSecilenKategori(kat); setSecilenAltKategori('tumu'); }}
                    className="relative overflow-hidden cursor-pointer group" style={{ height: '130px', marginBottom: '2px' }}>
                    {kat.medyaUrl && kat.medyaTip === 'video'
                      ? <video src={kat.medyaUrl} autoPlay muted loop className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      : kat.medyaUrl ? <img src={kat.medyaUrl} alt={kat.ad} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      : <div className="absolute inset-0" style={{ backgroundColor: temaRenk + '40' }} />}
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10" />
                    <div className="absolute inset-0 flex items-center justify-between px-5">
                      <div>
                        <h3 className="text-white font-bold text-base tracking-wide uppercase">{kat.ad}</h3>
                        <p className="text-white/60 text-xs mt-0.5">{urunSayisi} Ürün</p>
                      </div>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        ) : (
          <div>
            <div className="relative overflow-hidden" style={{ height: '160px' }}>
              {secilenKategori.medyaUrl && secilenKategori.medyaTip === 'video'
                ? <video src={secilenKategori.medyaUrl} autoPlay muted loop className="absolute inset-0 w-full h-full object-cover" />
                : secilenKategori.medyaUrl ? <img src={secilenKategori.medyaUrl} alt={secilenKategori.ad} className="absolute inset-0 w-full h-full object-cover" />
                : <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${temaRenk}, ${temaRenk}99)` }} />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 px-5 pb-4">
                <h2 className="text-white font-bold text-2xl uppercase tracking-wide">{secilenKategori.ad}</h2>
                <p className="text-white/60 text-sm">{kategoriUrunleri.length} Ürün</p>
              </div>
            </div>
            {altKategoriler.length > 0 && (
              <div className="border-b sticky top-[57px] z-10 bg-white">
                <div className="flex gap-2 px-4 py-3 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
                  <button onClick={() => setSecilenAltKategori('tumu')} className="flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold transition-all"
                    style={secilenAltKategori === 'tumu' ? { backgroundColor: temaRenk, color: 'white' } : { backgroundColor: '#f3f4f6', color: '#6b7280' }}>Tümü</button>
                  {altKategoriler.map(ak => (
                    <button key={ak} onClick={() => setSecilenAltKategori(ak)} className="flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold transition-all"
                      style={secilenAltKategori === ak ? { backgroundColor: temaRenk, color: 'white' } : { backgroundColor: '#f3f4f6', color: '#6b7280' }}>{ak}</button>
                  ))}
                </div>
              </div>
            )}
            <div className="p-4">
              {filtreliUrunler.length === 0 ? (
                <div className="p-8 text-center text-gray-400">Bu kategoride ürün yok</div>
              ) : filtreliUrunler.map(urun => <UrunKart key={urun.id} urun={urun} />)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// MASA MENÜSÜ
// ─────────────────────────────────────────────
function Menu() {
  const { cafeId, masaNo } = useParams();
  const [sepet, setSepet] = useState({});
  const [kategoriler, setKategoriler] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [kafeAdi, setKafeAdi] = useState('Cafe');
  const [tagline, setTagline] = useState('');
  const [gercekCafeId, setGercekCafeId] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [sosyalMedya, setSosyalMedya] = useState({});
  const [secilenKategori, setSecilenKategori] = useState(null);
  const [secilenAltKategori, setSecilenAltKategori] = useState('tumu');
  const [aksiyonButonlari, setAksiyonButonlari] = useState([]);
  const [temaRenk, setTemaRenk] = useState('#f97316');
  const [logoUrl, setLogoUrl] = useState('');
  const [dil, setDil] = useState(() => localStorage.getItem('menu_dil') || 'tr');
  const [showSplash, setShowSplash] = useState(true);
  const [kafePlan, setKafePlan] = useState('standart');
  const [menuModu, setMenuModu] = useState('tam');
  const [videoPopupAcik, setVideoPopupAcik] = useState(false);
  const [degerlendirmeSonrasiGoogle, setDegerlendirmeSonrasiGoogle] = useState(false);
  const [siparisVerildi, setSiparisVerildi] = useState(() => localStorage.getItem(`siparis_${cafeId}_${masaNo}`) === 'true');
  const [hesapIstendi, setHesapIstendi] = useState(() => localStorage.getItem(`hesap_${cafeId}_${masaNo}`) === 'true');
  const [adisyonAcik, setAdisyonAcik] = useState(false);
  const [adisyon, setAdisyon] = useState(null);
  const [aksiyonMesaj, setAksiyonMesaj] = useState('');
  const [oneriUrunler, setOneriUrunler] = useState([]);
  const [degerlendirmeAcik, setDegerlendirmeAcik] = useState(false);
  const [puan, setPuan] = useState(0);
  const [yorum, setYorum] = useState('');
  const [degerlendirmeTamamlandi, setDegerlendirmeTamamlandi] = useState(() => localStorage.getItem(`degerlen_${cafeId}_${masaNo}`) === 'true');
  const [arkaPlanVideoUrl, setArkaPlanVideoUrl] = useState('');
  const [blurYogunluk, setBlurYogunluk] = useState(8);
  const [overlayOpacity, setOverlayOpacity] = useState(0.55);
  const [pasif, setPasif] = useState(false);
  const [aramaAcik, setAramaAcik] = useState(false);
  const [secilenUrun, setSecilenUrun] = useState(null);
  const [favoriler, setFavoriler] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`fav_${cafeId}`) || '[]'); } catch { return []; }
  });
  const [favoriSekmesi, setFavoriSekmesi] = useState(false);
  const [kampanyalar, setKampanyalar] = useState([]);
  const [oneCikanUrunler, setOneCikanUrunler] = useState([]);
  const [sadakatAktif, setSadakatAktif] = useState(false);
  const [sadakatAcik, setSadakatAcik] = useState(false);
  const [sadakatTelefon, setSadakatTelefon] = useState(() => localStorage.getItem(`sadakat_tel_${cafeId}`) || '');
  const [sadakatIsim, setSadakatIsim] = useState('');
  const [sadakatDogrulandi, setSadakatDogrulandi] = useState(() => !!localStorage.getItem(`sadakat_tel_${cafeId}`));
  const [sadakatPuan, setSadakatPuan] = useState(0);
  const [sadakatAdim, setSadakatAdim] = useState('telefon');
  const [sadakatOtp, setSadakatOtp] = useState('');
  const [sadakatYukleniyor, setSadakatYukleniyor] = useState(false);
  const [kvkkOnay, setKvkkOnay] = useState(false);
  const [kvkkAcik, setKvkkAcik] = useState(false);
  const hesapKapatildiRef = useRef(false);
  const t = DILLER[dil];

  const dilDegistir = (yeniDil) => { setDil(yeniDil); localStorage.setItem('menu_dil', yeniDil); };

  const favoriToggle = (urunId) => {
    setFavoriler(prev => {
      const yeni = prev.includes(urunId) ? prev.filter(id => id !== urunId) : [...prev, urunId];
      localStorage.setItem(`fav_${cafeId}`, JSON.stringify(yeni));
      return yeni;
    });
  };

  const sepeteEkle = (urun) => setSepet(prev => ({ ...prev, [urun.id]: { ...urun, adet: (prev[urun.id]?.adet || 0) + 1 } }));
  const sepettenCikar = (urun) => setSepet(prev => {
    const yeni = { ...prev };
    if (yeni[urun.id]?.adet > 1) yeni[urun.id] = { ...yeni[urun.id], adet: yeni[urun.id].adet - 1 };
    else delete yeni[urun.id];
    return yeni;
  });

  useEffect(() => {
    const verileriGetir = async () => {
      try {
        const kafeRes = await fetch(`${BACKEND}/menu/kafe/${cafeId}`).then(r => r.json());
        if (!kafeRes || !kafeRes.cafeId) { setYukleniyor(false); return; }
        if (kafeRes.aktif === false) { setYukleniyor(false); setPasif(true); return; }
        setKafeAdi(kafeRes.ad || 'Cafe');
        setTagline(kafeRes.tagline || '');
        setGercekCafeId(kafeRes.cafeId);
        setSosyalMedya(kafeRes.sosyalMedya || {});
        if (kafeRes.aksiyonButonlari) setAksiyonButonlari(kafeRes.aksiyonButonlari);
        if (kafeRes.temaRenk) setTemaRenk(kafeRes.temaRenk);
        if (kafeRes.plan) setKafePlan(kafeRes.plan);
        if (kafeRes.logoUrl) setLogoUrl(kafeRes.logoUrl);
        if (kafeRes?.menuModu) setMenuModu(kafeRes.menuModu);
        if (kafeRes.videoUrl) setArkaPlanVideoUrl(kafeRes.videoUrl);
        if (kafeRes.blurYogunluk != null) setBlurYogunluk(kafeRes.blurYogunluk);
        if (kafeRes.overlayOpacity != null) setOverlayOpacity(kafeRes.overlayOpacity);
        const [k, u] = await Promise.all([
          fetch(`${BACKEND}/menu/${kafeRes.cafeId}`).then(r => r.json()),
          fetch(`${BACKEND}/menu/urunler/${kafeRes.cafeId}`).then(r => r.json()),
        ]);
        setKategoriler(Array.isArray(k) ? k : []);
        setUrunler(Array.isArray(u) ? u : []);
        try {
          const kamp = await fetch(`${BACKEND}/kampanya/aktif/${kafeRes.cafeId}`).then(r => r.json());
          if (Array.isArray(kamp)) setKampanyalar(kamp);          
          if (kafeRes.entegrasyon?.sadakatAktif) setSadakatAktif(true);
          try {
  const one = await fetch(`${BACKEND}/menu/one-cikanlar/${kafeRes.cafeId}`).then(r => r.json());
  if (Array.isArray(one)) setOneCikanUrunler(one);
} catch {}
        } catch {}
      } catch (err) { console.error(err); }
      setYukleniyor(false);
    };
    verileriGetir();
  }, [cafeId]);

  useEffect(() => {
    if (!gercekCafeId || degerlendirmeTamamlandi || !siparisVerildi) return;
    const masayiSifirla = () => {
      hesapKapatildiRef.current = true;
      localStorage.removeItem(`hesap_${cafeId}_${masaNo}`);
      localStorage.removeItem(`siparis_${cafeId}_${masaNo}`);
      localStorage.removeItem(`degerlen_${cafeId}_${masaNo}`);
      setHesapIstendi(false); setSiparisVerildi(false); setDegerlendirmeAcik(true);
    };
    const interval = setInterval(async () => {
      if (hesapKapatildiRef.current) return;
      try {
        const durumRes = await fetch(`${BACKEND}/siparisler/masa-durum/${gercekCafeId}/${masaNo}`).then(r => r.json());
        if (durumRes.durum === 'kapali') { masayiSifirla(); clearInterval(interval); return; }
        const adisyonRes = await fetch(`${BACKEND}/siparisler/adisyon/${gercekCafeId}/${masaNo}`).then(r => r.json());
        if (adisyonRes.urunler && adisyonRes.urunler.length === 0) { masayiSifirla(); clearInterval(interval); }
      } catch {}
    }, 5000);
    return () => clearInterval(interval);
  }, [gercekCafeId, masaNo, siparisVerildi, degerlendirmeTamamlandi]);

  useEffect(() => {
  if (!secilenUrun || !gercekCafeId) return;
  fetch(`${BACKEND}/siparisler/populer/${gercekCafeId}?kategoriId=${secilenUrun.kategoriId}`)
    .then(r => r.json())
    .then(data => {
      if (Array.isArray(data)) setOneriUrunler(data.filter(u => u.id !== secilenUrun.id).slice(0, 5));
    })
    .catch(() => {});
}, [secilenUrun, gercekCafeId]);

  const degerlendirmeGonder = async () => {
    if (puan === 0) { alert(t.puanSec); return; }
    try {
      await fetch(`${BACKEND}/siparisler/degerlendirme`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: gercekCafeId, masaNo, puan, yorum }),
      });
      setDegerlendirmeTamamlandi(true);
      localStorage.setItem(`degerlen_${cafeId}_${masaNo}`, 'true');
      if (sosyalMedya.googleMaps) setDegerlendirmeSonrasiGoogle(true);
      else setDegerlendirmeAcik(false);
    } catch { alert(t.hata); }
  };

  const degerlendirmeAtla = () => {
    setDegerlendirmeAcik(false); setDegerlendirmeSonrasiGoogle(false);
    setDegerlendirmeTamamlandi(true);
    localStorage.setItem(`degerlen_${cafeId}_${masaNo}`, 'true');
  };

  const adisyonuGetir = async () => {
    try {
      const res = await fetch(`${BACKEND}/siparisler/adisyon/${gercekCafeId}/${masaNo}`).then(r => r.json());
      setAdisyon(res); setAdisyonAcik(true);
    } catch { alert(t.adisyonAlinamadi); }
  };

  const toplamUrun = Object.values(sepet).reduce((acc, u) => acc + u.adet, 0);
  const toplamFiyat = Object.values(sepet).reduce((acc, u) => acc + u.fiyat * u.adet, 0);

  const siparisVer = async () => {
    const urunlerList = Object.values(sepet).map(u => ({ id: u.id, ad: u.ad, fiyat: u.fiyat, adet: u.adet }));
    try {
      await fetch(`${BACKEND}/siparisler`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: gercekCafeId, masaNo, urunler: urunlerList }),
      });
      alert(t.siparisAlindi); setSepet({}); setSiparisVerildi(true);
      localStorage.setItem(`siparis_${cafeId}_${masaNo}`, 'true');
    } catch { alert(t.hata); }
  };

  const garsonCagir = async () => {
    try {
      await fetch(`${BACKEND}/siparisler/garson-cagir`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: gercekCafeId, masaNo }),
      });
      alert(t.garsonCagrildi);
    } catch { alert(t.hata); }
  };

  const hesapIste = async () => {
    if (hesapIstendi) return;
    try {
      await fetch(`${BACKEND}/siparisler/hesap-iste`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: gercekCafeId, masaNo }),
      });
      setHesapIstendi(true); localStorage.setItem(`hesap_${cafeId}_${masaNo}`, 'true');
      alert(t.hesapGeliyor);
    } catch { alert(t.hata); }
  };

  const aksiyonGonder = async (buton) => {
    try {
      await fetch(`${BACKEND}/siparisler/garson-cagir`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId: gercekCafeId, masaNo, mesaj: `${buton.emoji} ${buton.ad}` }),
      });
      setAksiyonMesaj(`${buton.emoji} ${buton.ad} ${t.talepGonderildi}`);
      setTimeout(() => setAksiyonMesaj(''), 3000);
    } catch { alert(t.hata); }
  };

  const katSecici = (kat) => { setSecilenKategori(kat); setSecilenAltKategori('tumu'); };

  // Ürüne uygulanacak kampanyayı bul
  const kampanyaHesapla = (urun) => {
    const simdikiSaat = new Date();
    const saat = simdikiSaat.getHours() * 60 + simdikiSaat.getMinutes();
    for (const k of kampanyalar) {
      if (!k.aktif) continue;
      const uygulanir = !k.urunler?.length || k.urunler.includes(urun.id);
      if (!uygulanir) continue;
      if (k.tip === 'yuzde' || k.tip === 'happy_hour') {
        if (k.tip === 'happy_hour') {
          const [bH, bM] = k.baslangicSaat.split(':').map(Number);
          const [eH, eM] = k.bitisSaat.split(':').map(Number);
          if (saat < bH * 60 + bM || saat > eH * 60 + eM) continue;
        }
        const indirimli = Math.round(urun.fiyat * (1 - k.indirimOrani / 100));
        return { indirimli, orani: k.indirimOrani, ad: k.ad };
      }
    }
    return null;
  };

  if (yukleniyor) return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="text-white/60 text-sm">{t.menuYukleniyor}</div>
    </div>
  );

  if (pasif) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 px-6 text-center">
      <div className="text-5xl mb-6">🔒</div>
      <h1 className="text-xl font-bold text-white mb-3">Menü Geçici Olarak Kapalı</h1>
      <p className="text-white/50 text-sm">Bu menü şu anda aktif değil. Lütfen daha sonra tekrar deneyin.</p>
    </div>
  );

  const kategoriUrunleri = secilenKategori ? urunler.filter(u => u.kategoriId === secilenKategori.id) : [];
  const altKategoriler = secilenKategori ? [...new Set(kategoriUrunleri.map(u => u.altKategori).filter(Boolean))] : [];
  const filtreliUrunler = secilenKategori
    ? (secilenAltKategori === 'tumu' ? kategoriUrunleri : kategoriUrunleri.filter(u => u.altKategori === secilenAltKategori))
    : [];
  const favoriUrunler = urunler.filter(u => favoriler.includes(u.id));

  const UrunKart = ({ urun }) => (
    <div className="rounded-2xl shadow-sm mb-3 overflow-hidden cursor-pointer"
      style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.12)' : 'white', backdropFilter: arkaPlanVideoUrl ? 'blur(8px)' : 'none' }}
      onClick={() => setSecilenUrun(urun)}>
      {urun.resim && <div className="overflow-hidden h-40 relative">
        <img src={urun.resim} alt={urun.ad} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
        <button onClick={e => { e.stopPropagation(); favoriToggle(urun.id); }}
          className="absolute top-2 right-2 w-8 h-8 rounded-full bg-black/30 flex items-center justify-center text-lg">
          {favoriler.includes(urun.id) ? '❤️' : '🤍'}
        </button>
      </div>}
      <div className="p-4 flex justify-between items-center">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{urun.ad}</h3>
            {!urun.resim && (
              <button onClick={e => { e.stopPropagation(); favoriToggle(urun.id); }} className="text-lg">
                {favoriler.includes(urun.id) ? '❤️' : '🤍'}
              </button>
            )}
          </div>
          {urun.aciklama && <p className="text-sm mt-1" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#6b7280' }}>{urun.aciklama}</p>}
          {urun.kalori && <p className="text-xs mt-1" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af' }}>🔥 {urun.kalori} kcal{urun.alerjenler?.length > 0 && <span className="ml-2">⚠️ {urun.alerjenler.join(', ')}</span>}</p>}
          {(() => { const kamp = kampanyaHesapla(urun); return kamp ? (
            <div className="flex items-center gap-2 mt-2">
              <p className="font-bold text-lg" style={{ color: temaRenk }}>₺{kamp.indirimli}</p>
              <p className="text-sm line-through" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af' }}>₺{urun.fiyat}</p>
              <span className="text-xs bg-red-500 text-white px-1.5 py-0.5 rounded-full font-bold">-%{kamp.orani}</span>
            </div>
          ) : <p className="font-bold mt-2 text-lg" style={{ color: temaRenk }}>₺{urun.fiyat}</p>; })()}
        </div>
        <div className="flex items-center gap-2 ml-3" onClick={e => e.stopPropagation()}>
          {urun.stokta === false ? (
  <span className="text-xs font-semibold text-red-400 bg-red-50 px-3 py-1.5 rounded-full">Tükendi</span>
) : menuModu !== 'sadece_menu' && (
  <>
    {sepet[urun.id] && (
                <>
                  <button onClick={() => sepettenCikar(urun)} className="rounded-full w-9 h-9 flex items-center justify-center text-xl font-bold"
                    style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', color: arkaPlanVideoUrl ? 'white' : '#374151' }}>−</button>
                  <span className="font-bold w-5 text-center" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{sepet[urun.id].adet}</span>
                </>
              )}
              <button onClick={() => sepeteEkle(urun)} className="text-white rounded-full w-9 h-9 flex items-center justify-center text-xl font-bold shadow-sm" style={{ backgroundColor: temaRenk }}>+</button>
            </>
          )}
        </div>
      </div>
    </div>
  );

  // ── SPLASH ──
  if (showSplash) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
        style={{ backgroundColor: arkaPlanVideoUrl ? 'transparent' : '#1c1a17' }}>
        <MenuBackground videoUrl={arkaPlanVideoUrl} blurYogunluk={blurYogunluk} overlayOpacity={overlayOpacity} />
        {!arkaPlanVideoUrl && <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #ffffff 1px, transparent 1px)', backgroundSize: '60px 60px' }} />}
        <div className="relative z-10 flex flex-col items-center px-6 w-full max-w-sm">
          {logoUrl ? <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-white/20 mb-6 shadow-2xl"><img src={logoUrl} alt="logo" className="w-full h-full object-cover" /></div>
            : <div className="w-28 h-28 rounded-full border-2 border-white/20 mb-6 flex items-center justify-center text-5xl shadow-2xl" style={{ backgroundColor: temaRenk + '30' }}>🍽️</div>}
          <h1 className="text-3xl font-bold text-white mb-1 tracking-wider text-center">{kafeAdi.toUpperCase()}</h1>
          {tagline && <p className="text-white/50 text-sm mb-6 text-center">{tagline}</p>}
          {!tagline && <div className="mb-6" />}
          <button onClick={() => setShowSplash(false)} className="w-full flex items-center justify-between px-5 py-4 rounded-2xl mb-3 shadow-lg transition-all hover:opacity-90"
            style={{ backgroundColor: '#2a2620', border: '1px solid rgba(255,255,255,0.1)' }}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: temaRenk + '40' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>
              </div>
              <div className="text-left"><p className="text-white font-semibold text-sm">{t.menuGoruntule}</p><p className="text-white/40 text-xs">{t.dijitalMenuKesfedin}</p></div>
            </div>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
          </button>
          {sosyalMedya.videoUrl && (
            <button onClick={() => setVideoPopupAcik(true)} className="w-full flex items-center justify-between px-5 py-4 rounded-2xl mb-6 shadow-lg"
              style={{ backgroundColor: '#2a2620', border: '1px solid rgba(255,255,255,0.1)' }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#FF000030' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#FF0000" opacity="0.8"/><polygon points="10,8 16,12 10,16" fill="white"/></svg>
                </div>
                <div className="text-left"><p className="text-white font-semibold text-sm">{t.tanitimVideo}</p><p className="text-white/40 text-xs">▶ Videoyu izle</p></div>
              </div>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          )}
          {!sosyalMedya.videoUrl && <div className="mb-6" />}
          <div className="flex gap-3 mb-8 flex-wrap justify-center">
            {sosyalMedya.googleMaps && <a href={sosyalMedya.googleMaps} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #EA4335, #FBBC05)' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="white"/><circle cx="12" cy="9" r="2.5" fill="#EA4335"/></svg></div></a>}
            {sosyalMedya.whatsapp && <a href={`https://wa.me/${sosyalMedya.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></div></a>}
            {sosyalMedya.instagram && <a href={sosyalMedya.instagram} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #F58529, #DD2A7B, #8134AF)' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg></div></a>}
            {sosyalMedya.facebook && <a href={sosyalMedya.facebook} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #1877F2, #0d5fc7)' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></div></a>}
            {sosyalMedya.tiktok && <a href={sosyalMedya.tiktok} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #010101, #69C9D0)' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.19 8.19 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z"/></svg></div></a>}
            {sosyalMedya.youtube && <a href={sosyalMedya.youtube} target="_blank" rel="noreferrer"><div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #FF0000, #cc0000)' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg></div></a>}
          </div>
          <div className="flex flex-col items-center gap-2">
            <p className="text-white/30 text-xs">{t.dilSec}</p>
            <div className="flex rounded-full overflow-hidden" style={{ backgroundColor: '#2a2620', border: '1px solid rgba(255,255,255,0.1)' }}>
              <button onClick={() => dilDegistir('tr')} className="px-5 py-2 text-sm font-bold transition-all rounded-full" style={dil === 'tr' ? { backgroundColor: temaRenk, color: 'white' } : { color: 'rgba(255,255,255,0.5)' }}>TR</button>
              <button onClick={() => dilDegistir('en')} className="px-5 py-2 text-sm font-bold transition-all rounded-full" style={dil === 'en' ? { backgroundColor: temaRenk, color: 'white' } : { color: 'rgba(255,255,255,0.5)' }}>EN</button>
            </div>
          </div>
          <p className="text-white/20 text-xs mt-6">{t.masa} {masaNo}</p>
        </div>
        {videoPopupAcik && (
          <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={() => setVideoPopupAcik(false)}>
            <div className="w-full max-w-sm" onClick={e => e.stopPropagation()}>
              <div className="flex justify-between items-center mb-3">
                <p className="text-white font-semibold">{t.tanitimVideo}</p>
                <button onClick={() => setVideoPopupAcik(false)} className="text-white/60 hover:text-white text-2xl">✕</button>
              </div>
              <div className="relative w-full rounded-2xl overflow-hidden" style={{ paddingBottom: '56.25%' }}>
                <iframe src={sosyalMedya.videoUrl} className="absolute inset-0 w-full h-full" allowFullScreen title="Tanıtım videosu" allow="autoplay" />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ── MENÜ ──
  return (
    <div className="min-h-screen relative" style={{ backgroundColor: arkaPlanVideoUrl ? 'transparent' : '#f9fafb' }}>
      <MenuBackground videoUrl={arkaPlanVideoUrl} blurYogunluk={blurYogunluk} overlayOpacity={overlayOpacity} />

      {aramaAcik && (
        <AramaModal urunler={urunler} temaRenk={temaRenk} onKapat={() => setAramaAcik(false)}
          onUrunSec={u => { setSecilenUrun(u); setAramaAcik(false); }}
          sepet={sepet} onSepeteEkle={sepeteEkle} onSepettenCikar={sepettenCikar}
          arkaPlanVideoUrl={arkaPlanVideoUrl} t={t} />
      )}

      {secilenUrun && (
  <UrunDetayModal urun={secilenUrun} temaRenk={temaRenk} onKapat={() => setSecilenUrun(null)}
    onSepeteEkle={sepeteEkle} sepetteMi={!!sepet[secilenUrun?.id]}
    arkaPlanVideoUrl={arkaPlanVideoUrl} t={t}
    oneriUrunler={oneriUrunler}
    onUrunSec={u => setSecilenUrun(u)} />
)}

      <div className="relative z-10 max-w-md mx-auto pb-56">
        <div className="sticky top-0 z-10 shadow-sm" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : 'white', backdropFilter: arkaPlanVideoUrl ? 'blur(12px)' : 'none' }}>
          <div className="flex items-center justify-between px-4 py-3">
            <button onClick={() => { if (favoriSekmesi) { setFavoriSekmesi(false); } else if (secilenKategori) { setSecilenKategori(null); setSecilenAltKategori('tumu'); } else setShowSplash(true); }}
              style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#9ca3af' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            <div className="flex items-center gap-2">
              {logoUrl && <img src={logoUrl} alt="logo" className="w-7 h-7 rounded-full object-cover" />}
              <div className="text-center">
                <p className="text-sm font-bold leading-tight" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{kafeAdi}</p>
                {tagline && <p className="text-xs leading-tight" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>{tagline}</p>}
              </div>
            </div>
            <div className="flex items-center gap-1" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', borderRadius: '20px', padding: '2px' }}>
              <button onClick={() => dilDegistir('tr')} className="px-2 py-1 text-xs font-bold rounded-full transition-all" style={dil === 'tr' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>TR</button>
              <button onClick={() => dilDegistir('en')} className="px-2 py-1 text-xs font-bold rounded-full transition-all" style={dil === 'en' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>EN</button>
              {kafePlan === 'pro' ? (
              <>
              <button onClick={() => dilDegistir('ar')} className="px-2 py-1 text-xs font-bold rounded-full transition-all" style={dil === 'ar' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>AR</button>
              <button onClick={() => dilDegistir('ru')} className="px-2 py-1 text-xs font-bold rounded-full transition-all" style={dil === 'ru' ? { backgroundColor: temaRenk, color: 'white' } : { color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>RU</button>
              </>
           ) : (
             <span className="px-2 py-1 text-xs" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.3)' : '#d1d5db' }}>🔒</span>
          )}
            </div>
          </div>
        </div>

        {favoriSekmesi ? (
          <div className="p-4">
            <h2 className="font-bold text-lg mb-4" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>❤️ {t.favoriler}</h2>
            {favoriUrunler.length === 0 ? (
              <div className="text-center py-12" style={{ color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af' }}>
                <p className="text-4xl mb-3">🤍</p><p className="text-sm">{t.favoriYok}</p>
              </div>
            ) : favoriUrunler.map(urun => <UrunKart key={urun.id} urun={urun} />)}
          </div>
        ) : !secilenKategori ? (
          <div>
            {/* Öne Çıkan Ürünler Şeridi */}
{oneCikanUrunler.length > 0 && (
  <div className="px-4 pt-3 pb-1">
    <p className="text-xs font-bold mb-2 uppercase tracking-wider" style={{ color: temaRenk }}>⭐ Öne Çıkanlar</p>
    <div className="flex gap-3 overflow-x-auto pb-2" style={{ scrollbarWidth: 'none' }}>
      {oneCikanUrunler.map(urun => {
        const kamp = kampanyaHesapla(urun);
        return (
          <div key={urun.id} onClick={() => setSecilenUrun(urun)}
            className="flex-shrink-0 rounded-2xl overflow-hidden cursor-pointer shadow-sm"
            style={{ width: '140px', backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.12)' : 'white', backdropFilter: arkaPlanVideoUrl ? 'blur(8px)' : 'none' }}>
            {urun.resim
              ? <img src={urun.resim} alt={urun.ad} className="w-full object-cover" style={{ height: '90px' }} />
              : <div className="w-full flex items-center justify-center text-3xl" style={{ height: '90px', backgroundColor: temaRenk + '20' }}>🍽️</div>}
            <div className="p-2">
              <p className="font-semibold text-xs leading-tight" style={{ color: arkaPlanVideoUrl ? 'white' : '#1f2937' }}>{urun.ad}</p>
              {kamp ? (
                <div className="flex items-center gap-1 mt-1">
                  <p className="font-bold text-xs" style={{ color: temaRenk }}>₺{kamp.indirimli}</p>
                  <p className="text-xs line-through" style={{ color: '#9ca3af' }}>₺{urun.fiyat}</p>
                </div>
              ) : (
                <p className="font-bold text-xs mt-1" style={{ color: temaRenk }}>₺{urun.fiyat}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}
            {kategoriler.length === 0 ? <div className="p-12 text-center" style={{ color: '#9ca3af' }}>{t.menuHazirlanmamis}</div> : (
              kategoriler.map(kat => {
                const urunSayisi = urunler.filter(u => u.kategoriId === kat.id).length;
                return (
                  <div key={kat.id} onClick={() => katSecici(kat)} className="relative overflow-hidden cursor-pointer group" style={{ height: '130px', marginBottom: '2px' }}>
                    {kat.medyaUrl && kat.medyaTip === 'video' ? <video src={kat.medyaUrl} autoPlay muted loop className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      : kat.medyaUrl ? <img src={kat.medyaUrl} alt={kat.ad} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      : <div className="absolute inset-0 w-full h-full" style={{ backgroundColor: temaRenk + '40' }} />}
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10" />
                    <div className="absolute inset-0 flex items-center justify-between px-5">
                      <div><h3 className="text-white font-bold text-base tracking-wide uppercase">{kat.ad}</h3><p className="text-white/60 text-xs mt-0.5">{urunSayisi} {t.urunSayisi}</p></div>
                      <div className="flex items-center gap-1"><span className="text-white/70 text-sm">{t.goruntule}</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg></div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        ) : (
          <div>
            <div className="relative overflow-hidden" style={{ height: '160px' }}>
              {secilenKategori.medyaUrl && secilenKategori.medyaTip === 'video' ? <video src={secilenKategori.medyaUrl} autoPlay muted loop className="absolute inset-0 w-full h-full object-cover" />
                : secilenKategori.medyaUrl ? <img src={secilenKategori.medyaUrl} alt={secilenKategori.ad} className="absolute inset-0 w-full h-full object-cover" />
                : <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${temaRenk}, ${temaRenk}99)` }} />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 px-5 pb-4">
                <h2 className="text-white font-bold text-2xl uppercase tracking-wide">{secilenKategori.ad}</h2>
                <p className="text-white/60 text-sm">{kategoriUrunleri.length} {t.urunSayisi}</p>
              </div>
            </div>
            {altKategoriler.length > 0 && (
              <div className="border-b sticky top-[57px] z-10" style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : 'white', backdropFilter: arkaPlanVideoUrl ? 'blur(12px)' : 'none' }}>
                <div className="flex gap-2 px-4 py-3 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
                  <button onClick={() => setSecilenAltKategori('tumu')} className="flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold transition-all"
                    style={secilenAltKategori === 'tumu' ? { backgroundColor: temaRenk, color: 'white' } : { backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#6b7280' }}>{t.tumUrunler}</button>
                  {altKategoriler.map(ak => (
                    <button key={ak} onClick={() => setSecilenAltKategori(ak)} className="flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold transition-all"
                      style={secilenAltKategori === ak ? { backgroundColor: temaRenk, color: 'white' } : { backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.15)' : '#f3f4f6', color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.7)' : '#6b7280' }}>{ak}</button>
                  ))}
                </div>
              </div>
            )}
            <div className="p-4">
              {filtreliUrunler.length === 0 ? <div className="p-8 text-center" style={{ color: '#9ca3af' }}>{t.buKategorideUrunYok}</div>
                : filtreliUrunler.map(urun => <UrunKart key={urun.id} urun={urun} />)}
            </div>
          </div>
        )}
      </div>

      {/* Sadakat Kartı Modal */}
      {sadakatAcik && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end justify-center" onClick={e => { if (e.target === e.currentTarget) setSadakatAcik(false); }}>
          <div className="bg-white rounded-t-3xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-gray-800">🎁 Sadakat Kartım</h2>
              <button onClick={() => setSadakatAcik(false)} className="text-gray-400 text-2xl">✕</button>
            </div>

            {sadakatAdim === 'telefon' && (
  <div>
    <p className="text-sm text-gray-500 mb-4">10 siparişte 1 bedava! Telefon numaranızı girin.</p>
    <input value={sadakatIsim} onChange={e => setSadakatIsim(e.target.value)}
  placeholder="Adınız Soyadınız" type="text"
  className="w-full border border-gray-200 rounded-xl px-4 py-3 mb-3 focus:outline-none focus:border-orange-400 text-center" />
    <input value={sadakatTelefon} onChange={e => setSadakatTelefon(e.target.value)}
  placeholder="05XX XXX XX XX" type="tel"
  className="w-full border border-gray-200 rounded-xl px-4 py-3 mb-3 focus:outline-none focus:border-orange-400 text-center text-lg tracking-wider" />
    <label className="flex items-start gap-2 mb-4 cursor-pointer">
      <input type="checkbox" checked={kvkkOnay} onChange={e => setKvkkOnay(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-orange-500 flex-shrink-0" />
      <span className="text-xs text-gray-500 leading-relaxed">
        <button onClick={() => setKvkkAcik(true)} className="text-orange-500 underline">KVKK Aydınlatma Metni</button>'ni okudum, telefon numaramın işlenmesini kabul ediyorum.
      </span>
    </label>
    <button onClick={async () => {
      if (!kvkkOnay) { alert('Lütfen KVKK metnini onaylayın!'); return; }
                  if (!sadakatTelefon.trim()) { alert('Telefon numarası girin!'); return; }
                  setSadakatYukleniyor(true);
                  try {
                    const res = await fetch(`${BACKEND}/sadakat/otp-gonder`, {
                     method: 'POST', headers: { 'Content-Type': 'application/json' },
                     body: JSON.stringify({ cafeId: gercekCafeId, telefon: sadakatTelefon.replace(/\D/g, ''), isim: sadakatIsim }),
                      }).then(r => r.json());
                    if (res.basarili) setSadakatAdim('otp');
                    else alert(res.mesaj || 'Hata oluştu!');
                  } catch { alert('Hata!'); }
                  setSadakatYukleniyor(false);
                }} disabled={sadakatYukleniyor}
                  className="w-full text-white py-3 rounded-2xl font-semibold disabled:opacity-50"
                  style={{ backgroundColor: temaRenk }}>
                  {sadakatYukleniyor ? '⏳ Gönderiliyor...' : '📱 SMS Kodu Gönder'}
                </button>
              </div>
            )}

            {sadakatAdim === 'otp' && (
              <div>
                <p className="text-sm text-gray-500 mb-1">Doğrulama kodu gönderildi:</p>
                <p className="font-bold text-gray-800 mb-4">{sadakatTelefon}</p>
                <input value={sadakatOtp} onChange={e => setSadakatOtp(e.target.value)}
                  placeholder="- - - -" type="number" maxLength={4}
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 mb-4 focus:outline-none focus:border-orange-400 text-center text-3xl tracking-widest font-bold" />
                <button onClick={async () => {
                  setSadakatYukleniyor(true);
                  try {
                    const tel = sadakatTelefon.replace(/\D/g, '');
                    const res = await fetch(`${BACKEND}/sadakat/otp-dogrula`, {
                      method: 'POST', headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ cafeId: gercekCafeId, telefon: tel, otp: sadakatOtp }),
                    }).then(r => r.json());
                    if (res.basarili) {
                      localStorage.setItem(`sadakat_tel_${cafeId}`, tel);
                      setSadakatDogrulandi(true);
                      // Puan getir
                      const musteriRes = await fetch(`${BACKEND}/sadakat/musteri/${gercekCafeId}/${tel}`).then(r => r.json());
                      if (musteriRes) setSadakatPuan(musteriRes.puan || 0);
                      setSadakatAdim('kart');
                    } else alert(res.mesaj || 'Kod hatalı!');
                  } catch { alert('Hata!'); }
                  setSadakatYukleniyor(false);
                }} disabled={sadakatYukleniyor}
                  className="w-full text-white py-3 rounded-2xl font-semibold disabled:opacity-50"
                  style={{ backgroundColor: temaRenk }}>
                  {sadakatYukleniyor ? '⏳ Doğrulanıyor...' : '✅ Doğrula'}
                </button>
                <button onClick={() => setSadakatAdim('telefon')} className="w-full mt-2 text-gray-400 text-sm py-2">← Geri</button>
              </div>
            )}

            {(sadakatAdim === 'kart' || (sadakatDogrulandi && sadakatAdim === 'telefon')) && (
              <div>
                {sadakatAdim !== 'kart' && (async () => {
                  // localStorage'dan yüklü kullanıcı için puan getir
                  const tel = sadakatTelefon.replace(/\D/g, '');
                  if (tel && sadakatPuan === 0) {
                    try {
                      const r = await fetch(`${BACKEND}/sadakat/musteri/${gercekCafeId}/${tel}`).then(x => x.json());
                      if (r) setSadakatPuan(r.puan || 0);
                    } catch {}
                  }
                  return null;
                })()}
                <div className="text-center mb-6">
                  <p className="text-4xl mb-2">☕</p>
                  <p className="font-bold text-gray-800 text-lg mb-1">{sadakatTelefon}</p>
                  <p className="text-sm text-gray-500">{10 - sadakatPuan} sipariş kaldı, bedava kahve kazanıyorsunuz!</p>
                </div>
                <div className="grid grid-cols-5 gap-2 mb-6">
                  {Array.from({ length: 10 }, (_, i) => (
                    <div key={i} className="aspect-square rounded-xl flex items-center justify-center text-xl border-2"
                      style={{ backgroundColor: i < sadakatPuan ? temaRenk : 'transparent', borderColor: i < sadakatPuan ? temaRenk : '#e5e7eb' }}>
                      {i < sadakatPuan ? '☕' : '⬜'}
                    </div>
                  ))}
                </div>
                <div className="bg-orange-50 rounded-xl p-3 text-center">
                  <p className="text-sm text-orange-600 font-medium">{sadakatPuan}/10 ☕ tamamlandı</p>
                </div>
                <button onClick={() => { setSadakatAdim('telefon'); setSadakatDogrulandi(false); localStorage.removeItem(`sadakat_tel_${cafeId}`); setSadakatTelefon(''); setSadakatPuan(0); }}
                  className="w-full mt-3 text-gray-400 text-xs py-2">Farklı numara kullan</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* KVKK Modal */}
{kvkkAcik && (
  <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4" onClick={e => { if (e.target === e.currentTarget) setKvkkAcik(false); }}>
    <div className="bg-white rounded-2xl w-full max-w-md p-6 max-h-[80vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-gray-800">KVKK Aydınlatma Metni</h2>
        <button onClick={() => setKvkkAcik(false)} className="text-gray-400 text-2xl">✕</button>
      </div>
      <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, sadakat kartı sistemine kayıt olurken paylaştığınız telefon numaranız;{"\n\n"}
        • Sadakat puanlarınızın takibi ve bildirilmesi,{"\n"}
        • Doğrulama kodu (OTP) gönderimi,{"\n"}
        • Kampanya ve indirim bilgilendirmeleri (onay vermeniz halinde){"\n\n"}
        amaçlarıyla, işletme tarafından KVKK'ya uygun şekilde işlenmekte ve saklanmaktadır. Verileriniz üçüncü taraflarla paylaşılmaz, yalnızca SMS gönderim altyapısı aracılığıyla iletişim kurmak amacıyla kullanılır.{"\n\n"}
        KVKK'nın 11. maddesi kapsamındaki haklarınız (bilgi talep etme, düzeltme, silme vb.) için işletmeyle iletişime geçebilirsiniz.{"\n\n"}
        Bu metni onaylayarak telefon numaranızın yukarıdaki amaçlarla işlenmesine açık rıza vermiş olursunuz.
      </p>
      <button onClick={() => setKvkkAcik(false)} className="w-full mt-4 bg-orange-500 text-white py-3 rounded-2xl font-semibold">Anladım</button>
    </div>
  </div>
)}

      {/* Adisyon modal */}
      {adisyonAcik && adisyon && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end justify-center" onClick={e => { if (e.target === e.currentTarget) setAdisyonAcik(false); }}>
          <div className="bg-white rounded-t-3xl w-full max-w-md p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4"><h2 className="text-lg font-bold text-gray-800">{t.adisyonBaslik} — {t.masa} {masaNo}</h2><button onClick={() => setAdisyonAcik(false)} className="text-gray-400 text-2xl">✕</button></div>
            {adisyon.urunler.length === 0 ? <p className="text-center text-gray-400 py-8">{t.henuzSiparis}</p> : (
              <>{adisyon.urunler.map((u, i) => (<div key={i} className="flex justify-between items-center py-2 border-b border-gray-100"><div><span className="font-medium text-gray-800">{u.ad}</span><span className="text-gray-400 text-sm ml-2">x{u.adet}</span></div><span className="font-semibold text-gray-800">₺{u.toplam}</span></div>))}
              <div className="flex justify-between items-center mt-4 pt-3 border-t-2 border-gray-200"><span className="font-bold text-lg text-gray-800">{t.toplam}</span><span className="font-bold text-xl" style={{ color: temaRenk }}>₺{adisyon.genelToplam}</span></div></>
            )}
            <button onClick={() => setAdisyonAcik(false)} className="w-full mt-4 bg-gray-100 text-gray-600 py-3 rounded-2xl font-semibold">{t.kapat}</button>
          </div>
        </div>
      )}

      {/* Değerlendirme modal */}
      {degerlendirmeAcik && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end justify-center">
          <div className="bg-white rounded-t-3xl w-full max-w-md p-6">
            {!degerlendirmeSonrasiGoogle ? (
              <>{<h2 className="text-xl font-bold text-gray-800 text-center mb-2">{t.degerlendirBaslik}</h2>}<p className="text-gray-500 text-sm text-center mb-6">{t.degerlendirAlt}</p>
              <div className="flex justify-center gap-3 mb-6">{[1,2,3,4,5].map(star => (<button key={star} onClick={() => setPuan(star)} className={`text-4xl transition-transform hover:scale-110 ${star <= puan ? 'opacity-100' : 'opacity-30'}`}>⭐</button>))}</div>
              <textarea value={yorum} onChange={e => setYorum(e.target.value)} placeholder={t.yorumPlaceholder} rows={3} className="w-full border border-gray-200 rounded-xl px-4 py-3 mb-4 focus:outline-none resize-none text-sm" />
              <div className="flex gap-3"><button onClick={degerlendirmeAtla} className="flex-1 bg-gray-100 text-gray-600 py-3 rounded-2xl font-semibold hover:bg-gray-200">{t.atla}</button><button onClick={degerlendirmeGonder} className="flex-1 text-white py-3 rounded-2xl font-semibold" style={{ backgroundColor: temaRenk }}>{t.gonder}</button></div></>
            ) : (
              <><div className="text-center mb-6"><p className="text-4xl mb-3">🙏</p><h2 className="text-xl font-bold text-gray-800 mb-2">{t.tesekkurler}</h2><p className="text-gray-500 text-sm">{t.degerlendirmeAlindi}</p></div>
              <a href={sosyalMedya.googleMaps} target="_blank" rel="noreferrer" onClick={() => setDegerlendirmeAcik(false)} className="w-full flex items-center justify-center gap-3 py-4 rounded-2xl font-semibold text-white mb-3" style={{ background: 'linear-gradient(135deg, #EA4335, #FBBC05)' }}>⭐ {t.googleYorum}</a>
              <button onClick={() => setDegerlendirmeAcik(false)} className="w-full bg-gray-100 text-gray-600 py-3 rounded-2xl font-semibold">{t.atla}</button></>
            )}
          </div>
        </div>
        
      )}
       
{/* Alt bar */}
      {menuModu !== 'sadece_menu' && (
      <div className="fixed bottom-0 left-0 right-0 z-20"
        style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(20,20,20,0.85)' : 'white', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}>
        <div className="max-w-md mx-auto">
          <div className="px-4 pt-3 pb-2">
            {aksiyonButonlari.length > 0 && (
              <div className="mb-2">
                {aksiyonMesaj && <div className="bg-green-50 text-green-700 text-xs font-medium px-3 py-1.5 rounded-xl mb-2 text-center">✅ {aksiyonMesaj}</div>}
                <div className="grid grid-cols-3 gap-1.5">
                  {aksiyonButonlari.map((btn, i) => (
                    <button key={i} onClick={() => aksiyonGonder(btn)} className="border py-2 px-2 rounded-xl text-xs font-medium transition-all"
                      style={{ backgroundColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.1)' : '#f9fafb', borderColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.2)' : '#e5e7eb', color: arkaPlanVideoUrl ? 'rgba(255,255,255,0.8)' : '#374151' }}>
                      {btn.emoji} {btn.ad}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {toplamUrun > 0 && <div className="rounded-xl p-2 mb-2 flex justify-between items-center" style={{ backgroundColor: temaRenk + '15' }}><span className="text-gray-700 font-medium text-sm">{toplamUrun} {t.urun}</span><span className="font-bold text-sm" style={{ color: temaRenk }}>₺{toplamFiyat}</span></div>}
            {sadakatAktif && (
              <button onClick={async () => {
                if (sadakatDogrulandi) {
                  const tel = sadakatTelefon.replace(/\D/g, '');
                  try {
                    const r = await fetch(`${BACKEND}/sadakat/musteri/${gercekCafeId}/${tel}`).then(x => x.json());
                    if (r) setSadakatPuan(r.puan || 0);
                  } catch {}
                  setSadakatAdim('kart');
                } else {
                  setSadakatAdim('telefon');
                }
                setSadakatAcik(true);
              }} className="w-full text-white py-2 rounded-2xl font-semibold text-sm mb-2 flex items-center justify-center gap-2"
                style={{ background: 'linear-gradient(135deg, #a855f7, #7c3aed)' }}>
                🎁 Sadakat Kartım {sadakatDogrulandi ? `(${sadakatPuan}/10 ☕)` : ''}
              </button>
            )}
            <div className="flex gap-2 mb-2">
              <button onClick={garsonCagir} className="flex-1 text-white py-3 rounded-2xl font-semibold shadow-lg text-sm" style={{ backgroundColor: '#1f2937' }}>{t.garson}</button>
              {siparisVerildi && (
                <><button onClick={adisyonuGetir} className="flex-1 text-white py-3 rounded-2xl font-semibold shadow-lg text-sm" style={{ backgroundColor: '#3b82f6' }}>{t.adisyon}</button>
                <button onClick={hesapIste} disabled={hesapIstendi} className={`flex-1 py-3 rounded-2xl font-semibold shadow-lg text-sm transition-all ${hesapIstendi ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-green-500 text-white hover:bg-green-600'}`}>{hesapIstendi ? t.hesapIstendi : t.hesap}</button></>
              )}
              {toplamUrun > 0 && <button onClick={siparisVer} className="flex-1 text-white py-3 rounded-2xl font-semibold shadow-lg text-sm" style={{ backgroundColor: temaRenk }}>{t.siparisVer} ({toplamUrun})</button>}
            </div>
          </div>
          <div className="flex items-center border-t" style={{ borderColor: arkaPlanVideoUrl ? 'rgba(255,255,255,0.08)' : '#f3f4f6' }}>
            <button onClick={() => { setFavoriSekmesi(false); setSecilenKategori(null); setAramaAcik(false); }}
              className="flex-1 flex flex-col items-center gap-1 py-2"
              style={{ color: !favoriSekmesi && !aramaAcik ? temaRenk : (arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af') }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>
              <span className="text-xs font-medium">Menü</span>
            </button>
            <button onClick={() => { setAramaAcik(true); setFavoriSekmesi(false); }}
              className="flex-1 flex flex-col items-center gap-1 py-2"
              style={{ color: aramaAcik ? temaRenk : (arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af') }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <span className="text-xs font-medium">Ara</span>
            </button>
            <button onClick={() => { setFavoriSekmesi(true); setSecilenKategori(null); setAramaAcik(false); }}
              className="flex-1 flex flex-col items-center gap-1 py-2 relative"
              style={{ color: favoriSekmesi ? '#ef4444' : (arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af') }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill={favoriSekmesi ? '#ef4444' : 'none'} stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              {favoriler.length > 0 && <span className="absolute top-1 right-4 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-bold">{favoriler.length}</span>}
              <span className="text-xs font-medium">Favoriler</span>
            </button>
            <button onClick={toplamUrun > 0 ? siparisVer : undefined}
              className="flex-1 flex flex-col items-center gap-1 py-2 relative"
              style={{ color: toplamUrun > 0 ? temaRenk : (arkaPlanVideoUrl ? 'rgba(255,255,255,0.4)' : '#9ca3af') }}>
              <div className="relative">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                {toplamUrun > 0 && <span className="absolute -top-2 -right-2 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center" style={{ backgroundColor: temaRenk, fontSize: '10px' }}>{toplamUrun}</span>}
              </div>
              <span className="text-xs font-medium">{toplamUrun > 0 ? `₺${toplamFiyat}` : 'Sepet'}</span>
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
  );
}

function App() {
  const [kullanici, setKullanici] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length === 3 && parts[1] === '3amenu' && parts[2] === 'com') {
      const slug = parts[0];
      if (slug !== 'www') {
          window.location.href = `https://3amenu.com/menu/${slug}`;
        }
    }
    const unsub = onAuthStateChanged(auth, user => { setKullanici(user); setYukleniyor(false); });
    return () => unsub();
  }, []);
  if (yukleniyor) return <div className="min-h-screen flex items-center justify-center text-gray-400">Yükleniyor...</div>;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/menu/:cafeId" element={<PublicMenu />} />
        <Route path="/menu/:cafeId/:masaNo" element={<Menu />} />
        <Route path="/kasa" element={kullanici ? <KasaEkrani kullanici={kullanici} /> : <Navigate to="/login" />} />
        <Route path="/admin" element={kullanici ? <AdminPanel kullanici={kullanici} /> : <Navigate to="/login" />} />
        <Route path="/login" element={kullanici ? <Navigate to="/admin" /> : <Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/superadmin" element={kullanici ? <SuperAdmin kullanici={kullanici} /> : <Navigate to="/login" />} />
        <Route path="/mutfak" element={kullanici ? <MutfakEkrani kullanici={kullanici} /> : <Navigate to="/login" />} />
        <Route path="/odeme-basarili" element={<OdemeBasarili />} />
        <Route path="/odeme-hatasi" element={<OdemeHatasi />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;